(function () {
  function startAutoplay(slider, root) {
    if (!slider || slider.dataset.designlabAutoplayRunning === 'true') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    slider.dataset.designlabAutoplayRunning = 'true';

    try {
      slider.style.scrollBehavior = 'auto';
    } catch (e) {}

    var paused = false;
    var dir = document.documentElement.getAttribute('dir') || 'ltr';
    var rtl = dir === 'rtl';
    var speed = 0.55;

    function step() {
      if (!paused) {
        var max = slider.scrollWidth - slider.clientWidth;
        if (max > 0.5) {
          if (rtl) {
            slider.scrollLeft -= speed;
            if (slider.scrollLeft <= 0.5) {
              slider.scrollLeft = max;
            }
          } else {
            slider.scrollLeft += speed;
            if (slider.scrollLeft >= max - 0.5) {
              slider.scrollLeft = 0;
            }
          }
        }
      }
      window.requestAnimationFrame(step);
    }

    window.requestAnimationFrame(step);

    root.addEventListener(
      'mouseenter',
      function () {
        paused = true;
      },
      { passive: true }
    );
    root.addEventListener(
      'mouseleave',
      function () {
        paused = false;
      },
      { passive: true }
    );
    root.addEventListener(
      'touchstart',
      function () {
        paused = true;
      },
      { passive: true }
    );
    root.addEventListener(
      'touchend',
      function () {
        paused = false;
      },
      { passive: true }
    );
  }

  function findTarget() {
    var main = document.getElementById('MainContent');
    var root = null;
    if (main) {
      root = main.querySelector('slider-component[data-designlab-autoplay]');
    }
    if (!root) {
      root = document.querySelector('slider-component[data-designlab-autoplay]');
    }
    if (!root) return null;
    var slider = root.querySelector('[id^="Slider-"]');
    if (!slider) return null;
    return { root: root, slider: slider };
  }

  function init() {
    var t = findTarget();
    if (!t) return;
    startAutoplay(t.slider, t.root);
  }

  function initWithRetries() {
    init();
    if (!findTarget()) {
      window.setTimeout(init, 300);
      window.setTimeout(init, 1200);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWithRetries);
  } else {
    initWithRetries();
  }

  window.addEventListener('load', function () {
    init();
  });

  if (window.customElements && typeof window.customElements.whenDefined === 'function') {
    window.customElements.whenDefined('slider-component').then(function () {
      init();
    });
  }
})();
